import { BaseRouteService } from "./BaseRouteService";

/**
 * Service to communicate with inventory routes of the server application
 */
export class InventoryRouteService extends BaseRouteService {
    /**
     * Get the current player's inventory from the server application
     *
     * @returns A list of inventory items, each containing an alias and an optional image path
     */
    public async getInventory(): Promise<{ items: { alias: string; image: string | null }[] }> {
        return this.getJsonApi<{ items: { alias: string; image: string | null }[] }>("game/inventory");
    }
}
